// extracted by mini-css-extract-plugin
export default {"containerDefault":"Body_containerDefault__nJ43K"};